const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="no-content">
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/sky-nav/sky-nav.twig`, new Map([[`class`, `t-dark`], [`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])]])]])]]), false, false, 2));
                this.echo(`  <div class="o-container o-container--prose o-container--pad">
    <div class="o-container__content">
      <div class="u-text-center u-space-block-start-4 u-pad-block-4">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`, `734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`, 41, 5), new Map([[`class`, `o-rhythm--compact`]]), false, false, 41));
                this.echo(`      </div>
    </div>
  </div>
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])], [7, new Map([[`link`, `/portland-device-lab`], [`title`, `Device Lab`]])], [8, new Map([[`link`, `https://cloudfour-patterns.netlify.app/`], [`title`, `Patterns`]])], [9, new Map([[`link`, `https://www.responsivefieldday.com/`], [`title`, `Responsive Field Day`]])]])]])], [`social`, new Map([[`items`, new Map([[0, new Map([[`link`, `https://twitter.com/cloudfour`], [`title`, `Follow us on Twitter`], [`icon`, `brands/twitter`]])], [1, new Map([[`link`, `https://github.com/cloudfour`], [`title`, `Find us on GitHub`], [`icon`, `brands/github`]])], [2, new Map([[`link`, `https://www.instagram.com/cloudfourpdx/`], [`title`, `Follow us on Instagram`], [`icon`, `brands/instagram`]])], [3, new Map([[`link`, `https://www.linkedin.com/company/cloud-four`], [`title`, `Follow us on LinkedIn`], [`icon`, `brands/linkedin`]])]])]])], [`action`, new Map([[`lead_in`, `Let’s discuss your project!`], [`title`, `Email us`], [`link`, `mailto:info@cloudfour.com`], [`icon`, `envelope`]])], [`organization`, new Map([[`name`, `Cloud Four, Inc.`], [`address`, new Map([[`street_address`, `510 SW 3rd Ave, Suite 420`], [`address_locality`, `Portland`], [`address_region`, `Oregon`], [`postal_code`, `97204`], [`address_country`, `USA`]])], [`email`, `info@cloudfour.com`], [`telephone`, `+1 (503) 290-1090`], [`url`, `https://cloudfour.com/`], [`founding_date`, `2007-12-13`]])]]), false, false, 59));
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`, ``);
            }
        }],
        [5, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`, 41);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `magnifying-glass`], [`class`, `c-icon--x-large c-icon--muted`]]), true, false, 45));
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`, 2], [`content`, `Oops, nothing to see here.`]]), false, false, 49));
                this.echo(`            <p class="u-pad-block-start-n2">Sorry, there is no content to display. You might enjoy one of our <a href="#">recent articles</a> instead.</p>
          `);
            }

            getTemplateName() {
                return `734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155');

let template = env.loadTemplate('734be3790e74a4f2ceb6da35b0c444e7b76940aa52683188c8d3beeb2e0fa155');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/no-content/example/example.twig", args: context }
     );
     return rendered;;
};